import { FC } from 'react'

import { PageNavigationItem } from 'src/components/molecules/navigations/PageNavigationItem'

export type SettingNavigationType = 'customRole' | 'ip' | 'auth'

type Props = {
  navigationType: SettingNavigationType
  selectNavigation: (navigationType: SettingNavigationType) => void
  className?: string
}

export const SettingPageNavigation: FC<Props> = ({
  navigationType,
  selectNavigation,
  className,
}) => {
  return (
    <div className={className}>
      <div className="tw-rounded-[8px] tw-overflow-hidden tw-w-full tw-shadow-[0_5px_20px_0_rgba(122,137,160,0.10)]">
        <PageNavigationItem
          isSelected={navigationType === 'customRole'}
          text="カスタムロール"
          onClick={() => selectNavigation('customRole')}
          className="tw-w-full"
        />
        <PageNavigationItem
          isSelected={navigationType === 'ip'}
          text="IPアドレス制限"
          onClick={() => selectNavigation('ip')}
          className="tw-w-full"
        />
        <PageNavigationItem
          isSelected={navigationType === 'auth'}
          text="ログイン認証"
          onClick={() => selectNavigation('auth')}
          className="tw-border-t tw-border-border-primary tw-w-full"
        />
      </div>
    </div>
  )
}
